import { render, staticRenderFns } from "./staffbtn.vue?vue&type=template&id=5d8f6c3f&scoped=true&"
import script from "./staffbtn.vue?vue&type=script&lang=js&"
export * from "./staffbtn.vue?vue&type=script&lang=js&"
import style0 from "./staffbtn.vue?vue&type=style&index=0&id=5d8f6c3f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d8f6c3f",
  null
  
)

export default component.exports